import React from 'react'
import PageUnderConstruction from '../../../../component/Global/underconstruction/underconstruction'

function Integrations() {
  return (
    <section className='section container'>
      <h1>Integrations</h1>
      <PageUnderConstruction />
    </section>
  )
}

export default Integrations